import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Camera, Vote, Brain, Users } from "lucide-react";
import { PortalHeader, PortalFooter } from "./NassauToday";
import { getCampaigns, TYPE_META } from "../lib/promotions";

export const TYPE_ICON = { sweepstakes: Trophy, photo: Camera, ballot: Vote, quiz: Brain };
const FILTERS = [["", "All"], ["sweepstakes", "Sweepstakes"], ["photo", "Photo Contests"], ["ballot", "Best Of"], ["quiz", "Quizzes"]];

export default function Contests() {
  const [type, setType] = useState("");
  const [items, setItems] = useState([]);
  useEffect(() => { getCampaigns(type).then(setItems).catch(() => {}); }, [type]);
  return (
    <div className="portal" data-testid="contests-page">
      <PortalHeader />
      <main className="mx-auto max-w-7xl px-4 py-6 sm:py-8">
        <section className="p-fade mb-6 rounded-3xl bg-gradient-to-br from-[#CA6702] to-[#EE9B00] px-6 py-10 text-white sm:px-10">
          <p className="portal-chip flex items-center gap-1.5 text-white/80"><Trophy size={13} /> Contests & Promotions</p>
          <h1 className="font-portal mt-2 text-4xl font-black tracking-tight sm:text-5xl lg:text-6xl">Play, vote & win local.</h1>
          <p className="mt-3 max-w-xl text-sm text-white/85 sm:text-base">Sweepstakes, photo contests, quizzes and the Best of Nassau ballot, brought to you by local businesses.</p>
        </section>
        <div className="no-scrollbar mb-6 flex gap-2 overflow-x-auto">
          {FILTERS.map(([k, l]) => (
            <button key={k || "all"} onClick={() => setType(k)} data-testid={`contests-filter-${k || "all"}`}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold ${type === k ? "bg-[var(--p-ink)] text-white" : "bg-white text-slate-600 ring-1 ring-slate-200"}`}>{l}</button>
          ))}
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((c) => <CampaignCard key={c.id} c={c} />)}
        </div>
        {items.length === 0 && <p className="py-16 text-center text-slate-500">No campaigns here right now. Check back soon!</p>}
      </main>
      <PortalFooter />
    </div>
  );
}

function CampaignCard({ c }) {
  const Icon = TYPE_ICON[c.type] || Trophy;
  const meta = TYPE_META[c.type] || TYPE_META.sweepstakes;
  return (
    <Link to={`/contests/${c.id}`} data-testid={`campaign-card-${c.id}`} className="portal-card group flex flex-col overflow-hidden">
      <div className="relative h-44 overflow-hidden bg-slate-100">
        {c.image && <img src={c.image} alt={c.title} className={`h-full w-full object-cover transition-transform duration-500 group-hover:scale-105 ${c.type === "photo" ? "object-top" : ""}`} />}
        <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-white/95 px-2.5 py-1 text-[11px] font-bold text-[var(--p-ink)]"><Icon size={12} /> {meta.label}</span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <p className="font-portal text-lg font-extrabold leading-tight text-[var(--p-ink)]">{c.title}</p>
        {c.prize && <p className="mt-1 text-sm font-semibold text-[var(--p-clay)]">{c.prize}</p>}
        <div className="mt-auto flex items-center justify-between pt-4">
          {c.sponsor_name ? <span className="flex items-center gap-1 text-xs text-slate-400"><Users size={12} /> Presented by {c.sponsor_name}</span> : <span />}
          <span className="rounded-full bg-[var(--p-teal)] px-3 py-1.5 text-xs font-bold text-white">{meta.verb}</span>
        </div>
      </div>
    </Link>
  );
}
